import React from "react";
import { Box } from "@chakra-ui/react";
import { FillImage } from "components/images";
import { TextTitle } from "ui/text";
import { Button } from "ui/button";
import { MediaAccordion } from "ui/accordion";
import composableCdpImage from "../../../../public/assets/shared-illustrations/composable-cdp.png";
import secondAccordionImage from "../../../../public/assets/platform/identity-resolution/cdp-accordion-2.png";
import thirdAccordionImage from "../../../../public/assets/platform/identity-resolution/cdp-accordion-3.png";
import fourthAccordionImage from "../../../../public/assets/platform/identity-resolution/cdp-accordion-4.png";

export function IdrCdpAccordion() {
  return (
    <Box>
      <TextTitle
        align="center"
        size="lg"
        theme="dark"
        mb={{ base: "biggest", md: "huge" }}
        title="Resolve identities in your data warehouse, not a black box"
        description="Traditional Customer Data Platforms perform identity resolution within their own rigid systems. You don’t have control, and you have to store your data with them. Instead, Hightouch unifies customer profiles directly in your data warehouse."
        actions={
          <Button hasRightChevron href="/platform/composable-cdp">
            The Composable CDP
          </Button>
        }
      />

      <MediaAccordion
        variant="dynamic"
        theme="dark"
        items={[
          {
            title: "Leverage your existing data",
            content:
              "Hightouch is built around your data warehouse. It brings a full set of CDP capabilities to your existing data investment without requiring any change to your tech stack, copying of data, or introducing security risks.",
            media: (
              <FillImage
                src={composableCdpImage}
                alt="Flow between the the data warehouse, Hightouch as a Composable CDP, and user's integration ecosystem."
              />
            ),
          },
          {
            title: "Use all of your data, not just “CDP data”",
            content:
              "Traditional CDPs are limited to user and event data they collect. With Hightouch, you can leverage all of your data, from any source. Bring together any number of customer identifiers, from any place they interact with your brand.",
            media: <FillImage src={secondAccordionImage} alt="TODO" />,
          },
          {
            title: "Keep control of your data",
            content:
              "Hightouch doesn’t store your data and offers advanced governance features and granular control for how you use your data to resolve customer identities.",
            media: <FillImage src={thirdAccordionImage} alt="TODO" />,
          },
          {
            title: "Make decisions informed by complete visibility",
            content:
              "Stay one step ahead of potential issues and gain confidence with full visibility into identity resolution. There’s no black box: you stay in the driver’s seat.",
            media: <FillImage src={fourthAccordionImage} alt="TODO" />,
          },
        ]}
      />
    </Box>
  );
}
